import { prefixerI } from '.'

export const ROUTE_COTIZACIONES = prefixerI('cotizaciones')
export const ROUTE_COSTOS_COTIZACIONES = prefixerI('costos-cotizaciones')
export const ROUTE_HISTORIAL_PRECIOS = prefixerI('historial-precios')
export const ROUTE_ITEM_X_ORDENES_COMPRA = prefixerI('item-x-ordenes-compra')
export const ROUTE_ORDENES_COMPRA_VS_RECEPCION_BODEGA = prefixerI('ordenes-compra-vs-recepcion-bodega')
export const ROUTE_ORDENES_COMPRA_X_STATUS = prefixerI('ordenes-compra-x-status')
export const ROUTE_ORDENES_ENTREGA_X_STATUS = prefixerI('ordenes-entrega-x-status')
export const ROUTE_RECEPCIONES_ORDEN_ENTREGA = prefixerI('recepciones-orden-entrega')
export const ROUTE_SEGUIMIENTO_SOLICITUDES = prefixerI('seguimiento-solicitudes')
export const ROUTE_SOLICITUDES_X_ITEM = prefixerI('solicitudes-x-item')
export const ROUTE_SOLICITUDES_X_STATUS = prefixerI('solicitudes-x-status')
